// TEMP GUARD: делает new URLSearchParams() безопасным для "не того" инпута.
// Сними после тотальной миграции на parseFilters/useUrlFilters.
const Native = URLSearchParams;

class SafeURLSearchParams extends Native {
  constructor(init?: any) {
    // если прилетел object/WindowLocation/что-угодно без @@iterator — конвертим в пары
    if (init && typeof init === "object" && !(init instanceof Native) && !Array.isArray(init)) {
      try {
        const it = (init as any)[Symbol.iterator];
        if (typeof it !== "function") {
          init = Object.entries(init).map(([k, v]) => [k, String(v)]);
        }
      } catch {
        /* no iterator, convert to entries */
        init = Object.entries(init).map(([k, v]) => [k, String(v)]);
      }
    }
    try {
      super(init as any);
    } catch (e) {
      // крайний случай: падаем в пустую, но не роняем приложение
      super("");
      try {
        if (init && typeof init === "object") {
          for (const [k, v] of Object.entries(init)) this.append(k, String(v));
        }
      } catch {
        /* failed to append entries */
      }
      // можно отправить в Sentry breadcrumb
      console.warn("SafeURLSearchParams: coerced invalid init", e, init);
    }
  }
}

// @ts-expect-error - intentionally overriding global URLSearchParams
globalThis.URLSearchParams = SafeURLSearchParams;